export default "__VITE_ASSET__CCmD6Opo__"